import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { heroImage } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream px-5 pb-14 pt-8 sm:px-8 md:pt-12" data-id="element-152" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-5xl" data-id="element-153" data-mp="4mi4zf9wxwgl">
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center" data-id="element-154" data-mp="4jm4bj6oktog">
          <p className="font-display text-xl font-bold tracking-tight text-ink" data-id="element-155" data-mp="128pjbgw0r365">
            Dr. Karito
          </p>
          <span className="hidden h-4 w-px bg-gold/50 sm:block" aria-hidden="true" data-id="element-156" data-mp="x8jmlmaw6qh7" />
          <p className="rounded-full border border-gold/50 bg-white px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.14em] text-gold-deep" data-id="element-157" data-mp="s9gic42qkoaa">
            🦷 Resin Architect™
          </p>
        </div>

        <h1 className="mt-7 text-center font-display text-[32px] font-bold leading-[1.1] tracking-tight text-ink sm:text-5xl md:text-[56px]" data-id="element-158" data-mp="3czfny6wb6l9q">
          Plan your anterior composite cases in{' '}
          <span className="italic text-gold-deep" data-id="element-159" data-mp="3j6fvvj9ob1ao">15 minutes or less</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15px] leading-relaxed text-clay sm:text-lg" data-id="element-160" data-mp="3o6u71a6kmrcx">
          A visual clinical decision system that shows you what to assess, which material
          properties matter, how to approach layering and what sequence to follow —{' '}
          <span className="font-semibold text-ink" data-id="element-161" data-mp="30ggezjnzksic">before</span> you start the case.
        </p>

        <p className="mx-auto mt-4 max-w-xl text-center text-[14px] leading-relaxed text-ink/75 sm:text-base" data-id="element-162" data-mp="35aatm8oqihak">
          Includes <strong className="font-bold text-ink" data-id="element-163" data-mp="2qhqurk8mavyx">6 premium volumes</strong>,{' '}
          <strong className="font-bold text-ink" data-id="element-164" data-mp="2vjg50xo0n5ly">5 professional bonuses</strong> and{' '}
          <strong className="font-bold text-ink" data-id="element-165" data-mp="2hkggdq0i6qps">40+ clinical matrices</strong>, decision tools,
          protocols and checklists.
        </p>

        <div className="mt-8" data-id="element-166" data-mp="s21hi9lxc9yx">
          <img src={heroImage} alt="The complete Resin Architect™ system: 6 volumes, clinical matrices, checklists and digital access" className="mx-auto w-full max-w-3xl" width={1080} height={1080} data-id="element-167" data-mp="s2b8o0ipgn67" />
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-168" data-mp="ddf082cql852">
          <CtaButton label="Get Resin Architect™" microcopy="Instant access · One-time payment of $27 USD · Lifetime access · 7-day guarantee" currencyNote data-id="element-169" data-mp="deq4e3a3ghwp" />
        </div>

        <span id="cta-anchor" className="mt-2 block h-px w-full" aria-hidden="true" data-id="element-170" data-mp="15zq5vrf79z8q" />

        <Countdown className="mt-9" data-id="element-171" data-mp="110wq1scfxw5e" />

        <div className="mx-auto mt-8 max-w-xl" data-id="element-172" data-mp="x1edbjurwrdn">
          <ScarcityBar data-id="element-173" data-mp="x0l2o7sp1hq8" />
        </div>
      </div>
    </header>;
}